export enum RoundType {
  League = 'league',
  CupGroup = 'cupgroup',
  CupKo = 'cupko',
}
